import React from "react";

import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'
import {component_tool} from '@/tool';
const { WizModal } = component_tool

let componentName = 'syncEmailConfig';

const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })
const positionCategoryConfig = WizTableForm.Config.positionCategory(this, { apiParams: { state: 1 } })

import Editor from './editor'
const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "品牌",
      name: "orgId",
      dataIndex: "orgId",
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio'
      },
    },
    {
      title: "品牌",
      name: "orgList",
      dataIndex: "orgList",
      tableItem: {
        render: (text) => {
          return text?.map(item => item.name).join() || '';
        }
      },
    },
    {
      title: "岗位分类",
      name: "positionCategoryId",
      dataIndex: "positionCategoryId",
      searchItem: {
        ...positionCategoryConfig,
        diy: WizTableForm,
        selectType: 'radio'
      },
    },
    {
      title: "岗位分类",
      name: "positionCategoryList",
      dataIndex: "positionCategoryList",
      tableItem: {
        render: (text) => {
          return text?.map(item => item.name).join() || '';
        }
      },
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      dict: [
        {code: 0, codeName: '禁用'},
        {code: 1, codeName: '启用'},
      ],
      tableItem: {},
      searchItem: {
        type: 'select'
      },
    },
    {
      title: "邮箱",
      name: "email",
      dataIndex: "email",
      searchItem: {},
    },
    {
      title: "邮箱",
      name: "emailList",
      dataIndex: "emailList",
      tableItem: {
        render: (text) => {
          return text?.join() || '';
        }
      },
    },
  ]
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'editorAdd',
                  modalParams: {
                    title: '新增',
                    style: { minWidth: 700 },
                    diy: (e) => {
                      let editorProps = {
                        key: self.state.AddTimestamp,
                        ref: r => r && r.getWrappedInstance(),
                        editorSuccess: () => {
                          self.setState({AddTimestamp: new Date().getTime()})
                        },
                        ...e
                      }
                      return <Editor {...editorProps} />
                    },
                    onCancel: () => {
                      self.setState({ AddTimestamp: new Date().getTime() })
                    },
                    footer: false,
                    width: 680
                  },
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['update', 'enableOrDisable'],
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: { children: '编辑' },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'editorUpdate',
                modalParams: {
                  title: '编辑',
                  style: { minWidth: 700 },
                  diy: (e) => {
                    let editorProps = {
                      key: self.state.AddTimestamp,
                      ref: r => r && r.getWrappedInstance(),
                      editorSuccess: () => {
                        self.setState({AddTimestamp: new Date().getTime()})
                      },
                      ...e
                    }
                    return <Editor {...editorProps} />
                  },
                  onCancel: () => {
                    self.setState({ AddTimestamp: new Date().getTime() })
                  },
                  footer: false,
                  width: 680
                },
              }
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: { children: "禁用/启用" },
            textFormat: {
              recordKey: 'state',
              dirt: {  1: '禁用', 0: "启用" }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "setState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  (record['state'] === 0 ? "启用" : "禁用")}？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 1 ? 0 : 1,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          }
        ],
        commonOperate: {},
      }
    }
  };
}

const apis = () => {
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    save: {
      path: `${componentName}/save`,
      payload: {
        key: `${componentName}@save`,
        apiParams: {}
      }
    },
    setState: {
      path: `${componentName}/setState`,
      payload: {
        key: `${componentName}@setState`,
        apiParams: {}
      }
    },
  }
}

let reduxTemplateConfig = (args) => {
  return {
    apis: apis(),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
